import Masonry from '../components/masonry';

export default class BlogCards {
    constructor(element) {
        this.blogCards = element
        this.masonry = this.blogCards.querySelector('.masonry')
        new Masonry(this.masonry)
    }
}